<template>
  <div class="mt-3" id="odinIndicadorRealAtoProcessamento">

    <card :loading-full="loading">
      <card-content v-if="!loading">

        <AlertAtosIA :numeros="atos.map(a => a.codigo)"/>

        <div class="alert alert-outline-danger mb-3 w-100 small" v-if="atosSemTexto.length > 0">
          Antes de realizar a análise via IA dos atos, certifique-se de que todos eles estejam cadastrados e com o texto correto.
        </div>

        <div class="d-flex align-items-start">
          <div class="mr-auto">
            <p class="text-muted pb-2 mb-2 small">
              <template v-if="atosSelecionados.length > 0">{{atosSelecionados.length}} ato(s) selecionado(s)</template>
              <template v-else>Nenhum ato selecionado</template>
            </p>
          </div>

          <!-- Saída da trava: atos validados não são alterados pela IA; aqui o usuário remove a
               validação (com confirmação e auditoria) sem sair da tela de análise. -->
          <button type="button" class="btn btn-sm btn-outline-danger mr-2" v-if="atosValidados.length > 0"
                  @click.prevent="removerValidacaoLote()"
                  title="Remover a validação de atos travados — eles voltam a ser editáveis pela IA">
            <i class="fa fa-unlock mr-1"></i> Remover validação ({{atosValidados.length}})
          </button>

          <v-button :run="processarAtos" :button="true" v-if="atosSelecionados.length > 0"
                    :popover="true" position="dropleft" class="btn btn-sm btn-outline-success icon">
            <template #default="{ loading: btnLoading }">
              <template v-if="btnLoading">
                Processando: {{lotes.atual}}/{{lotes.total}}
              </template>
              <template v-else>
                Processar Atos
              </template>
            </template>
          </v-button>
        </div>

        <card-table class="table-striped mb-2">
          <thead>
            <tr>
              <th style="width: 40px">
                <i v-if="atosSelecionados.length > 0" @click="toggleSelectAll(false)"
                   title="Limpar Seleção" class="pointer fa-solid fa-circle-check text-success"></i>
                <i v-else @click="toggleSelectAll(true)"
                   title="Selecionar Todos" class="pointer fa-solid fa-circle-dashed"></i>
              </th>
              <th style="width: 40px">Número</th>
              <th style="width: 45px">Tipo</th>
              <th class="">Data</th>
              <th class="">Título</th>
              <th></th>
              <th class="" style="width: 70px"></th>
              <th class="" style="width: 30px"></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="ato in atos">
              <tr :key="ato.id || ato.codigo">

                <td class="text-center">
<!--                  <i v-if="ato.validado" class="pointer fa-solid fa-check text-success" title="Ato Já Validado no Sistema"></i>-->
                  <template v-if="!ato.validado">
                    <i v-if="ato.selecionado" @click="$set(ato, 'selecionado', false)" class="pointer fa-solid fa-circle-check text-primary"></i>
                    <i v-else @click="$set(ato, 'selecionado', true)" class="pointer fa-solid fa-circle-dashed"></i>
                  </template>

                </td>

                <td class="text-center">{{ato.codigo}}</td>

                <td class="text-center">{{ato.tipo == 'AVERBACAO' ? 'AV' : ato.tipoSigla}}</td>
                <td>{{$formatters.date(ato.registro)}}</td>
                <td class="small">{{ato.titulo || '-'}}</td>

                <td class="lborder text-center text-success" v-if="ato.possuiTexto" title="Possui texto cadastrado"><i class="fa-solid fa-text"></i></td>
                <td class="lborder text-center text-danger" v-else title="Não possui texto cadastrado"><i class="fa-solid fa-text-slash"></i></td>

                <td class="lborder">
                  <template v-if="ato.possuiTexto">
                    <i class="ml-2 fa-solid fa-microchip-ai pointer"
                       :class="{'text-success': ato.possuiSituacaoJuridica}" @click.prevent="abrirAto(ato)"></i>
                  </template>
                </td>

                <td class="lborder">
                    <i v-if="ato.validado" class="fal fa-check-double text-success pointer"
                       title="Ato validado — clique para remover a validação"
                       @click.prevent="removerValidacao(ato)"></i>
                    <i v-else class="fal fa-check-double" title="Ato Não Validado"></i>
                </td>

              </tr>
            </template>
          </tbody>
        </card-table>
      </card-content>

    </card>

  </div>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import CardTable from "@/components/Layout/components/CardTable.vue";
import ModalOdinProcessamentoAto from "@/views/Odin/modais/ModalOdinProcessamentoAto.vue";
import ModalRemoverValidacaoAtos from "@/views/Odin/componentes/ModalRemoverValidacaoAtos.vue";
import OdinBusiness from "@/views/Odin/OdinBusiness";
import AlertAtosIA from "@/components/alert/AlertAtosIA.vue";

export default {
  name: "OdinIndicadorRealAtosProcessamento",
  components: {AlertAtosIA, CardTable, CardContent, Card},
  props: {
    indicadorRealId: String,
    dataBus: {
      type: Object,
      request: true
    }
  },
  data() {
    return {
      lotes:{
        atual: 0,
        total: 0
      },
      loading: true,
      textos: [],
      atos:[],
      ctrl:{
        toggleSelecao:false
      }
    };
  },
  computed:{
    atosSelecionados(){
      return this.atos?.filter(r => !!r.selecionado)
    },
    atosSemTexto(){
      return this.atos?.filter(r => !r.possuiTexto)
    },
    // Atos travados pela validação — são os que podem ser destravados por esta tela.
    atosValidados(){
      return this.atos?.filter(r => !!r.validado && !!r.id) || []
    },
  },
  async mounted() {
    await this.load();
  },
  methods:{
    async load(){
      this.$set(this, 'loading', true);
      let atos = await this.$api.get(`api/odin/acompanhamento-matriculas/${this.indicadorRealId}/atos`)
        .catch(e => {
          FrontBusiness.showError('', e.message);
          return [];}
      );
      atos = atos?.map(a => {
        a.tipoSigla = a.codigo == 0 ? 'M' : a.tipo == 'AVERBACAO' ? 'AV' : 'R'
        return a;
      })

      this.$set(this, 'atos', atos);
      this.$set(this, 'loading', false);
    },

    toggle(key, ato, valor){
      this.$set(ato, key, valor);
    },

    async abrirAto(ato){
      await FrontBusiness.openModal(ModalOdinProcessamentoAto,
        {atoId: ato.id, indicadorRealId: this.indicadorRealId});
      await this.load();
    },

    // Abre a confirmação expressa de remoção da validação (motivo obrigatório + auditoria por ato)
    // e recarrega a lista ao fechar — parte do lote pode ter sido destravada.
    async abrirRemocaoValidacao(lista){
      const alvos = (lista || []).filter(a => a.validado && a.id).map(a => ({
        id: a.id,
        label: `${a.tipoSigla}.${a.codigo}`,
        descricao: a.titulo,
      }));
      if(!alvos.length){
        return;
      }
      await FrontBusiness.openModal(ModalRemoverValidacaoAtos, {atos: alvos});
      await this.load();
    },

    removerValidacao(ato){
      return this.abrirRemocaoValidacao([ato]);
    },

    removerValidacaoLote(){
      return this.abrirRemocaoValidacao(this.atosValidados);
    },

    toggleSelectAll(result){
        this.atos.forEach(ato => {
          if(!ato.validado){
            this.$set(ato, 'selecionado', result);
          }
        });
    },

    async processarAtos(){
      this.$set(this.lotes, 'total', this.atosSelecionados.length);
      this.lotes.atual = 0;
      let r = false;
      for(let pos in this.atosSelecionados) {
        ++this.lotes.atual;
        const id = this.atosSelecionados[pos]?.id;
        if(id){
          r = await OdinBusiness.realizarExtracaoAto(id, false, true).catch(r => {
            FrontBusiness.showError('', r.message);
            return false;
          });

          await FrontBusiness.sleep(100);

          if(!r){
            break;
          }
        }
      }

      if(r){
        FrontBusiness.showSuccess('', 'Atos Processados');
      }

      this.load();

    }

  }
};
</script>

<style lang="scss">
#odinIndicadorRealAtoProcessamento{
  th.rborder, td.rborder{
    border-right: 1pt solid gray;
  }
  th.lborder, td.lborder{
    border-left: 2pt solid var(--asgard-input);
  }
}
</style>
